import React from 'react';
import PropTypes from 'prop-types';
import { CardActions, CardContent, Divider } from '@material-ui/core';
import { Button } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../../knock-design-system';

export const SAVE_BUTTON_TEXT = 'Save Changes';
export const UNDO_BUTTON_TEXT = 'Undo Changes';

const useCss = makeCss({
  cardContent: {
    flex: 1,
    overflow: 'auto',
  },
  cardActions: {
    justifyContent: 'end',
    gap: '8px',
    padding: '16px',
  },
});

const TabView = ({
  children,
  handleOnSave,
  handleOnUndo,
  isActionsDisabled,
}) => {
  const css = useCss();

  return (
    <React.Fragment>
      <CardContent css={css.cardContent}>{children}</CardContent>

      <Divider />

      <CardActions css={css.cardActions}>
        <Button
          disabled={isActionsDisabled}
          onClick={handleOnUndo}
          variant="text"
        >
          {UNDO_BUTTON_TEXT}
        </Button>

        <Button disabled={isActionsDisabled} onClick={handleOnSave}>
          {SAVE_BUTTON_TEXT}
        </Button>
      </CardActions>
    </React.Fragment>
  );
};

TabView.propTypes = {
  children: PropTypes.node,
  handleOnUndo: PropTypes.func,
  handleOnSave: PropTypes.func,
  isActionsDisabled: PropTypes.bool,
};

export default TabView;
